<template>
  <div class="abstract-skeleton">
    <jw-skeleton>
      <div class="skeleton-wrap">
        <jw-skeleton-line :rows="1" :lineHeight="32" />
        <div class="skeleton-content">
          <jw-skeleton-shape v-for="i in 4" :key="i" />
        </div>
      </div>
    </jw-skeleton>
  </div>
</template>

<script setup></script>

<style scoped lang="less">
@import './index.less';
</style>
